module.exports = __webpack_public_path__ + "img/banner.cc207c11.png";